import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=556a4a10&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"
import style0 from "./Chip.vue?vue&type=style&index=0&id=556a4a10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a4a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556a4a10')) {
      api.createRecord('556a4a10', component.options)
    } else {
      api.reload('556a4a10', component.options)
    }
    module.hot.accept("./Chip.vue?vue&type=template&id=556a4a10&scoped=true", function () {
      api.rerender('556a4a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/Chip.vue"
export default component.exports